(function () {
  'use strict';

  var galleryEl = document.querySelector('media-gallery');
  var SECTION_ID = galleryEl ? galleryEl.id.replace('MediaGallery-', '') : '';

  var VARIANT_SPECS = {
    '5500U-512GB': {
      'Central processing unit': 'AMD Ryzen 5 5500U（6 cores 12 threads,2.1-4.0GHz）',
      'Graphics processing unit': 'AMD Radeon Graphics',
      'Operating system': 'Windows 11',
      'Display': '15.6", 1920×1080, 16:9',
      'Memory': '16GB DDR4',
      'Storage': '512GB SSD',
      'Battery': '54.72Wh (11.4V/4800mAh)',
      'Connection ports': 'Type-C(Full function)×2, HDMI×1, USB3.0×1, Ø3.5mm headphone Slot×1, USB3.0×1, USB2.0×1, Micro SD Slot×1, Kensington Security Slot×1',
      'Wireless connectivity': 'Wi-Fi 6, Bluetooth 5.2',
      'Webcam': 'Front 0.9MP',
      'Power adapter': '65W PD charger',
      'Size': '357 × 227 × 23 mm',
      'Weight': '1644g'
    },
    '5500U-1TB': {
      'Central processing unit': 'AMD Ryzen 5 5500U（6 cores 12 threads,2.1-4.0GHz）',
      'Graphics processing unit': 'AMD Radeon Graphics',
      'Operating system': 'Windows 11',
      'Display': '16", 2560×1600, 16:10',
      'Memory': '16GB DDR4',
      'Storage': '1TB SSD',
      'Battery': '54.72Wh (11.4V/4800mAh)',
      'Connection ports': 'USB2.0×1, USB3.0×2, HDMI×1, TYPE-C×2 Full function, Audio Ø3.5mm×1, Type-C charging, Micro SD Card×1, Micro SD×1, Notebook Security Lock Hole×1',
      'Wireless connectivity': 'Wi-Fi 6, Bluetooth 5.2',
      'Webcam': '2.0MP',
      'Power adapter': '65W PD charger',
      'Size': '360×227×20mm',
      'Weight': '1850g'
    },
    '5825U-1TB': {
      'Central processing unit': 'AMD Ryzen 7 5825U (8 Cores, 16 Threads, up to 4.5 GHz)',
      'Graphics processing unit': 'AMD Radeon Graphics',
      'Operating system': 'Windows 11',
      'Display': '15.6", 1920×1080, 16:9',
      'Memory': '16GB DDR4',
      'Storage': '1TB SSD',
      'Battery': '57Wh (11.4V/5000mAh)',
      'Connection ports': 'DC in×1, TYPE-C×2 full function, HDMI×1, USB3.0×1, Ø3.5mm headphone jack×1, USB3.0×1, USB2.0×1, Kensington Security Slot×1',
      'Wireless connectivity': 'Wi-Fi 6, Bluetooth 5.2',
      'Webcam': '1.0MP',
      'Power adapter': '65W PD charger',
      'Size': '357 × 227 × 23 mm',
      'Weight': '1644g'
    }
  };

  var VARIANT_HIGHLIGHTS = {
    '5500U-512GB': [
      '<b>AMD Ryzen™ 5 5500U Processor:</b> 6 cores, 12 threads, 2.1-4.0GHz — smooth multitasking for everyday work & entertainment',
      '<b>15.6" FHD Display:</b> 1920×1080, 16:9 — crisp visuals for work and streaming',
      '<b>16GB DDR4 RAM + 512GB SSD:</b> Fast boot and responsive performance for daily use',
      '<b>Wi-Fi 6, Bluetooth 5.2:</b> Ultra-fast wireless connectivity for seamless browsing and file transfer',
      '<b>54.72Wh Battery (11.4V/4800mAh):</b> All-day battery life to keep you productive',
      '<b>65W PD Charger:</b> Fast charging, ready when you are',
      '<b>Backlit Keyboard & Fingerprint Security:</b> Work comfortably day or night with added security'
    ],
    '5500U-1TB': [
      '<b>AMD Ryzen™ 5 5500U Processor:</b> 6 cores, 12 threads, 2.1-4.0GHz — powerful performance for work and entertainment',
      '<b>16" 2.5K Display:</b> 2560×1600, 16:10 — stunning clarity with more screen real estate',
      '<b>16GB DDR4 RAM + 1TB SSD:</b> Ample storage and fast performance for power users',
      '<b>Wi-Fi 6, Bluetooth 5.2:</b> Next-gen wireless for lag-free connectivity',
      '<b>54.72Wh Battery (11.4V/4800mAh):</b> Long-lasting battery for all-day use',
      '<b>65W PD Charger:</b> Efficient fast charging on the go',
      '<b>Backlit Keyboard & Fingerprint Security:</b> Work comfortably day or night with added security'
    ],
    '5825U-1TB': [
      '<b>AMD Ryzen™ 7 5825U Processor:</b> 8 cores, 16 threads, up to 4.5GHz — premium performance for demanding tasks',
      '<b>15.6" FHD Display:</b> 1920×1080, 16:9 — vibrant visuals for work and entertainment',
      '<b>16GB DDR4 RAM + 1TB SSD:</b> High-capacity storage with blazing-fast speeds',
      '<b>Wi-Fi 6, Bluetooth 5.2:</b> Cutting-edge wireless for ultra-stable connections',
      '<b>57Wh Battery (11.4V/5000mAh):</b> Extended battery life for heavy workloads',
      '<b>65W PD Charger:</b> Fast and efficient charging',
      '<b>Backlit Keyboard & Kensington Security Slot:</b> Work comfortably and securely anywhere'
    ]
  };

  function preloadDescImages() {
    var blocks = document.querySelectorAll('[data-variant-desc]');
    blocks.forEach(function (block) {
      var imgs = block.querySelectorAll('img');
      imgs.forEach(function (img) {
        var src = img.getAttribute('src');
        if (src) {
          var preload = new Image();
          preload.src = src;
        }
      });
    });
  }

  function getVariantKey(variant) {
    if (!variant) return null;
    var cpu = variant.option1 || '';
    var storage = variant.option2 || '';
    var cpuKey = cpu.indexOf('5500U') !== -1 ? '5500U' : cpu.indexOf('5825U') !== -1 ? '5825U' : null;
    var storageKey = storage.indexOf('512') !== -1 ? '512GB' : storage.indexOf('1TB') !== -1 ? '1TB' : null;
    if (!cpuKey || !storageKey) return null;
    return 'variant-' + cpuKey + '-' + storageKey;
  }

  function getDescKey(variant) {
    if (!variant) return null;
    var cpu = variant.option1 || '';
    var storage = variant.option2 || '';
    var cpuKey = cpu.indexOf('5500U') !== -1 ? '5500U' : cpu.indexOf('5825U') !== -1 ? '5825U' : null;
    var storageKey = storage.indexOf('512') !== -1 ? '512GB' : storage.indexOf('1TB') !== -1 ? '1TB' : null;
    if (!cpuKey || !storageKey) return null;
    return cpuKey + '-' + storageKey;
  }

  function updateGallery(variantKey) {
    var thumbList = document.querySelector('#Slider-Thumbnails-' + SECTION_ID);
    if (!thumbList) return;
    var thumbs = thumbList.querySelectorAll('.thumbnail-list__item');
    var firstMatchBtn = null;
    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      var isTagged = alt.indexOf('variant-') === 0;
      if (!isTagged) {
        thumb.style.display = '';
      } else if (alt === variantKey) {
        thumb.style.display = '';
        if (!firstMatchBtn) firstMatchBtn = thumb.querySelector('button');
      } else {
        thumb.style.display = 'none';
      }
    });
    if (firstMatchBtn) firstMatchBtn.click();
  }

  function updateDescription(descKey) {
    var blocks = document.querySelectorAll('[data-variant-desc]');
    if (!blocks.length) return;
    blocks.forEach(function (block) {
      block.style.display = block.getAttribute('data-variant-desc') === descKey ? '' : 'none';
    });
  }

  function updateSpecs(descKey) {
    var specs = VARIANT_SPECS[descKey];
    if (!specs) return;
    var rows = document.querySelectorAll('table tbody tr');
    rows.forEach(function (row) {
      var th = row.querySelector('th');
      var td = row.querySelector('td');
      if (!th || !td) return;
      var fieldName = th.textContent.trim();
      if (specs[fieldName] !== undefined) {
        var span = td.querySelector('span');
        if (span) span.textContent = specs[fieldName];
        else td.textContent = specs[fieldName];
      }
    });
  }

  function updateHighlights(descKey) {
    var highlights = VARIANT_HIGHLIGHTS[descKey];
    if (!highlights) return;
    var span = document.querySelector('.product__rte span.metafield-multi_line_text_field');
    if (!span) return;
    span.innerHTML = highlights.map(function (item) {
      return '● ' + item;
    }).join('<br>');
  }

  function updateFromVariantId(variantId) {
    var productJson = document.getElementById('product-json');
    if (!productJson) return;
    try {
      var productData = JSON.parse(productJson.textContent);
      var matched = productData.variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (matched) {
        var key = getVariantKey(matched);
        var descKey = getDescKey(matched);
        if (key) updateGallery(key);
        if (descKey) {
          updateDescription(descKey);
          updateSpecs(descKey);
          updateHighlights(descKey);
        }
      }
    } catch (err) {}
  }

  function getVariantFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  function init() {
    setTimeout(preloadDescImages, 500);
    var lastVariant = getVariantFromUrl();

    var origReplaceState = history.replaceState;
    history.replaceState = function () {
      origReplaceState.apply(this, arguments);
      setTimeout(function () {
        var current = getVariantFromUrl();
        if (current && current !== lastVariant) {
          lastVariant = current;
          updateFromVariantId(current);
        }
      }, 0);
    };

    var origPushState = history.pushState;
    history.pushState = function () {
      origPushState.apply(this, arguments);
      setTimeout(function () {
        var current = getVariantFromUrl();
        if (current && current !== lastVariant) {
          lastVariant = current;
          updateFromVariantId(current);
        }
      }, 0);
    };

    window.addEventListener('popstate', function () {
      var current = getVariantFromUrl();
      if (current && current !== lastVariant) {
        lastVariant = current;
        updateFromVariantId(current);
      }
    });

    var initVariant = getVariantFromUrl();
    if (initVariant) {
      setTimeout(function () { updateFromVariantId(initVariant); }, 50);
    } else {
      var productJson = document.getElementById('product-json');
      if (productJson) {
        try {
          var productData = JSON.parse(productJson.textContent);
          if (productData.variants && productData.variants[0]) {
            var key = getVariantKey(productData.variants[0]);
            var descKey = getDescKey(productData.variants[0]);
            if (key) setTimeout(function () { updateGallery(key); }, 50);
            if (descKey) {
              setTimeout(function () {
                updateDescription(descKey);
                updateSpecs(descKey);
                updateHighlights(descKey);
              }, 50);
            }
          }
        } catch (err) {}
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
